import React from 'react'

import { StatusCellEnum } from './status-cell.enum'
import { Icon } from '../../atoms'
import { IconName } from '../../atoms/icons/icon'

interface StatusCellProps {
  iconName: IconName
  status: StatusCellEnum
  label: JSX.Element | string
}

export const StatusCell: React.FC<StatusCellProps> = ({
  status,
  label,
  iconName,
}) => {
  const statusClasses: { [key in StatusCellEnum]: string } = {
    [StatusCellEnum.ACTIVE]: 'text-orange-500 bg-orange-100 border-orange-500',
    [StatusCellEnum.CONFIRMED]: 'text-green-500 bg-green-100 border-green-500',
    [StatusCellEnum.APPROVAL]:
      'text-turquoise-500 bg-turquoise-100 border-turquoise-500',
    [StatusCellEnum.CANCELED]: 'text-red-500 bg-red-100 border-red-500',
    [StatusCellEnum.CLOSED]: 'text-grey-700 bg-grey-100 border-grey-700',
  }

  return (
    <div
      className={`flex items-center gap-2 rounded-md border border-dashed p-3 ${statusClasses[status]}`}
    >
      <div className='w-4'>
        <Icon name={iconName} className={`w-full ${statusClasses[status]}`} />
      </div>
      <div className='leading-none'>
        {typeof label === 'string' ? <span>{label}</span> : label}
      </div>
    </div>
  )
}
